import React from "react";

// @material-ui/core
// core components
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import CompleteBackupTable from "components/Table/CompleteBackupTable";
import { Box } from '@mui/material';

export default function Backup() {
  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12} lg={12}>
          <MDBox>
            <BasicTabs/>
          </MDBox>
        </Grid>
      </Grid>
    </div>
  );
}


function BasicTabs() {
  return (
    <Box sx={{ width: '100%' }}>
        <CompleteBackupTable/>
    </Box>
  );
}